import styled, { css } from 'styled-components'

import { COLORS } from 'consts/colors'
import { DURATIONS, EASING, RADII } from 'styles/consts'
import { TButtonType } from './types'

const buttonStylesByType: Record<TButtonType, ReturnType<typeof css>> = {
  primary: css`
    background-color: ${COLORS.primary};
    color: ${COLORS.white};

    & > svg path {
      fill: ${COLORS.white};
    }

    &:hover {
      background-color: ${COLORS.primaryHover};
    }
  `,
  secondary: css`
    background-color: ${COLORS.surface};
    color: ${COLORS.textPrimary};
    border: 1px solid ${COLORS.border};

    &:hover {
      background-color: ${COLORS.fill};
    }
  `,
  white: css`
    background-color: ${COLORS.surface};
    color: ${COLORS.textSecondary};

    &:hover {
      color: ${COLORS.textPrimary};
    }
  `,
  light: css`
    background: ${COLORS.primaryTint};
    color: ${COLORS.primary};
    &:hover {
      background: ${COLORS.fillStrong};
    }
  `
}

const disabledStyles = css`
  opacity: 0.5;
  cursor: default;
  pointer-events: none;
`

export const Button = styled.button<{
  $isDisabled?: boolean
  $type: TButtonType
}>`
  height: 34px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: ${RADII.field};
  gap: 10px;
  padding: 9px 23px;
  box-sizing: border-box;
  font-size: 14px;
  font-weight: 500;
  border: none;
  cursor: pointer;
  transition:
    background-color ${DURATIONS.fast} ${EASING.out},
    border-color ${DURATIONS.fast} ${EASING.out},
    color ${DURATIONS.fast} ${EASING.out},
    transform ${DURATIONS.fast} ${EASING.out};

  &:active {
    transform: scale(0.97);
  }

  &:focus-visible {
    outline: 2px solid ${COLORS.primary};
    outline-offset: 2px;
  }

  ${({ $type }) => buttonStylesByType[$type]};
  ${({ $isDisabled }) => $isDisabled && disabledStyles};
`
